import React, { useMemo } from 'react'
import _ from 'lodash'
import { useForm, useField } from 'react-form'
import loadingGif from '../../assets/img/loading-pinwheel.gif'
import InputField from '../../components/form/InputField'
import HintButton from '../../components/HintButton'

function CheckboxField(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps, setValue } = useField(props.name)
  function onCheckboxChange(e) {
    if(e.target.checked){
      setValue(props.value)
    } else {
      setValue(undefined)
    }
  }
  return <input {...props} {...getInputProps(props)} onChange={onCheckboxChange} />
}

const RemoveStudentsForm = props => {
  const { isSubmitting, onSaveRosterClick, onDeleteStudentsClick, onSubmit, errors, formValues, activityIndicator, activityHint } = props
  const { Form, values } = useForm({
    defaultValues: useMemo(()=> formValues,[]),
    onSubmit: values=>onSubmit(values)
  })

  return(
    <Form>
      <table className="table table-striped" id="stripedTable">
        <thead>
          <tr>
            <th className='checkbox-col'>     </th>
              <th className='one-thirteenth-width activity-indicator-header'>
                Activity 
                <HintButton
                hint={activityHint('activity')}
                alignment={'left'}
                arrowDirection={'down'}
                iconColor={'#6D5CAE'}
                hintBoxColor={'white'}
                hintTextColor={'black'}
              />
            </th>
            <th className='two-thirteenth-width'>First Name</th>
            <th className='two-thirteenth-width'>Last Name</th>
            <th className='four-thirteenth-width'>
              Username/Email
              <HintButton
                hint={activityHint('username/email')}
                isActivityHint={true}
                alignment={'left'}
                arrowDirection={'down'}
                iconColor={'#6D5CAE'}
                hintBoxColor={'white'}
                hintTextColor={'black'}
              />
            </th>
            <th className='four-thirteenth-width'>Password</th>
          </tr>
        </thead>
        <tbody aria-label='Student roster delete mode'>
          {_.map(formValues.students, (student,index) => (
            <tr className='show-row' key={student.id}>
              <td className="v-align-middle semi-bold checkbox-col">
                <CheckboxField className="roster-checkboxes" type='checkbox' value={true} name={`students[${index}].isSelected`} />
              </td>
              <td className="v-align-middle semi-bold one-thirteenth-width">
                {activityIndicator[student.profile.uuid]}
              </td>
              <td className="v-align-middle semi-bold two-thirteenth-width">
                <p>{student.profile.firstName}</p>
              </td>
              <td className="v-align-middle semi-bold two-thirteenth-width">
                <p>{student.profile.lastName}</p>
              </td>
              <td className="v-align-middle semi-bold four-thirteenth-width">
                <p>{student.profile.username}</p>
              </td>
              <td className="v-align-middle semi-bold four-thirteenth-width">
                <p>{student.profile.password || <span className='hint-text'>Password can no longer be viewed</span>}</p>
                </td>
            </tr>
          ))}
        </tbody>
      </table>
      <br/>
      <div className='roster-control-bottom'>
        {!_.isEmpty(errors) && <div className='error'>{errors.join(',')}</div>}
        <button disabled={isSubmitting} type='submit' className='no-print btn rmv-btn-grp'>Transfer Students</button>
        <button disabled={isSubmitting} type='button' onClick={()=>onDeleteStudentsClick(values.students)} className='no-print btn rmv-btn-grp delete-btn'>Delete Students</button>
        &nbsp;&nbsp;
        <button disabled={isSubmitting} type='button' onClick={onSaveRosterClick} style={{ border:'1px solid white' }} className='no-print btn btn-primary save-roster-button'>Save Roster</button>
        <img className={`loading-gif ${isSubmitting ? '' : 'hidden'}`} src={loadingGif}/>
      </div>
    </Form>
  )
}

export default RemoveStudentsForm
